<template>
<div id="contents">

  <div id="works" class="page_contents">
    <div id="works_contents">
      <div id="works_guide_index">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/works/program/title.png" width="225" alt="WORKS" />
            <span>制作実績</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <worksPageNav/>

        <div id="guide">

          <div id="guide_contents">

            <div id="guide_contents_main">

              <div class="guide_container">
                <div class="guide_container_header">
                  <h2><img src="../assets/img/works/video-archive/tv-asahi_archive_logo.png" alt="" width="251"></h2>
                </div><!-- .guide_container_header -->
                <div class="guide_header header01">
                  <h2 class="guide_header_title">ご利用案内</h2>
                  <p>当社保有映像のご利用方法は以下の手順になります。</p>
                </div><!-- .guide_header -->

                <div class="guide_box arrow_box" id="registration">
                  <h3>①利用者登録</h3>
                  <div class="guide_box_inner">
                    <p>下記の利用者登録により、仮登録をお願いします。</p>
                    <p><a href="https://vivia-library.appspot.com/lib/user/register" target="_blank" class="register_link">https://vivia-library.appspot.com/lib/user/register</a></p>
                    <p>確認メールが届きますので、メール内リンクにアクセスすれば本登録完了となります。<br />10分以内に確認メールが届かない場合、メールアドレスが違っている可能性がありますので再度仮登録からお願いします。</p>
                  </div><!-- .guide_box_inner -->
                </div><!-- .guide_box -->

                <div class="guide_box arrow_box" id="search">
                  <h3>②検索</h3>
                  <div class="guide_box_inner">
                    <p>テレビ朝日映像アーカイブの検索機能より、検索ください。</p>
                    <p class="case"><span>映像が見られない、見つからない場合</span><br />探しの映像、御社名、ご担当者名、連絡先を記入の上、メールでお問合わせください。</p>
                    <p class="tv-archive_mail">メール　<a href="mailto:archive@tv-asahipro.co.jp">archive@tv-asahipro.co.jp</a></p>
                    <p class="case"><span>検索画面で映像が見られない場合</span><br />試写をすることができます。希望の映像をカートに入れ試写申請していただくか、<a href="http://www.tv-asahipro.co.jp/pdf/sisya.pdf" target="_blank" class="palt">「試写申込書」</a> をご利用ください。試写は当社にお越しいただくことになります。</p>
                  </div><!-- .guide_box_inner -->
                </div><!-- .guide_box -->

                <div class="guide_box arrow_box">
                  <h3>③利用申請</h3>
                  <div class="guide_box_inner">
                    <p>検索し、希望の映像をカートに入れて利用申請ください。担当者よりご連絡いたします。<br />数日経っても返信がない場合はお手数ですが、メールでお問合わせください。<br /><span class="application_form">※カートでの申請が出来なかった場合は<a href="http://www.tv-asahipro.co.jp/pdf/sinsei.pdf" target="_blank">「利用申請書」</a>をご利用ください。</span></p>
                  </div><!-- .guide_box_inner -->
                </div><!-- .guide_box -->

                <div class="guide_box arrow_box">
                  <h3>④映像の貸し出し</h3>
                  <div class="guide_box_inner">
                    <p>当社で貸出し用SSDにダビングしますので、お手数ですが当社までお越しいただきお受取りください。<br />送付も承りますが、送料は着払いとさせていただきますので、ご了承ください。<br />※申請書に記載された範囲を超えて使用することは出来ません。<br />※貸出し映像の複製保存一切出来ません。作業上複製した場合は、作業後速やかに消去してください。</p>
                  </div><!-- .guide_box_inner -->
                </div><!-- .guide_box -->

                <div class="guide_box arrow_box">
                  <h3>⑤使用報告</h3>
                  <div class="guide_box_inner">
                    <p class="palt specification">映像利用後、 「使用明細書」 に記入した期日までに<a href="http://www.tv-asahipro.co.jp/pdf/siyoumeisai.pdf" target="_blank"> 「使用報告書」</a> を、 押印の上、 FAXもしくはメール、 郵送にて提出ください。 当社の映像を使用した作品のコピー (DVDなど) も提出ください。</p>
                    <p class="siyoumeisai_btn"><a href="http://www.tv-asahipro.co.jp/pdf/siyoumeisai.pdf" download="siyoumeisai.pdf" class="btn">使用明細書</a></p>
                  </div><!-- .guide_box_inner -->
                </div><!-- .guide_box -->

                <div class="guide_box">
                  <h3>⑥請求</h3>
                  <div class="guide_box_inner">
                    <p>当社の定めた<a href="#price" class="price_link">映像利用料金表</a>に基づき、ご利用料金を請求させて頂きます。使用明細書の提出がなかった場合、貸し出しの全尺数を利用したみなし、ご請求させて頂きます。</p>
                    <div class="information_box">
                      <div class="information_box_inner">
                        <h4>テレビ朝日映像アーカイブ</h4>
                        <p>住所：<br />〒106-0032 東京都港区六本木1-1-1<br />アーク放送センター<br />メール：archive@tv-asahipro.co.jp<br />TEL：03-3587-8165<br />(営業時間 平日10時～18時)<br />FAX：03-3505-3772</p>
                      </div>
                    </div>
                  </div><!-- .guide_box_inner -->
                </div><!-- .guide_box -->

              </div><!-- .guide_container -->

              <div class="guide_container">
                <div class="guide_header header02">
                  <h2 class="guide_header_title">ご利用上の注意</h2>
                  <p class="palt" style="text-align: left;">テレビ朝日映像では、 映像を利用していただくにあたり、 以下の点をお願いしております。 映像の使用を申し込まれた際には、 これらについてご承諾いただいたものとします。</p>
                </div><!-- .guide_header -->

                <div class="guide_box">
                  <div class="guide_box_inner caution">
                    <p>●貸出し映像は、映像使用申請書に記載された作品のみへの使用とし、他用途への転用や二次使用を禁止します。別作品でのご使用は改めてお申し込みください。</p>
                    <p>●貸出し映像の複製保存は禁止します。編集などで複製が必要な場合には、作業後速やかに消去してください。貸出し用SSDもご返却願います。</p>
                    <p>●使用確定した秒数を映像使用明細書提出日までにご報告いただけなかった場合、貸出し映像の全秒数を使用確定秒数とさせていただきます。</p>
                    <p class="warning">上記に反した場合、当社から損害賠償を請求する場合があります。</p>
                    <p>●各種権利処理（肖像権、パブリシティー権等）が必要な映像についても貸出しはしていますが、これらの処理は利用者の責任において行ってください。</p>
                    <p>●貸出し映像の使用が違法行為に関わる場合、当社の業務に支障をきたす場合、公序良俗に反するとみなされる場合、その他各種権利侵害の恐れがある場合は、貸出しをお断りします。</p>
                    <p>●貸出し映像を使用して完成された作品の使用地域は、原則として日本国内のみとさせていただいきます。海外での使用につきましてはあらかじめご相談ください。</p>
                    <p>●映像使用にあたり、原則として当社から提供された映像であることを表示願います。（例：映像提供　テレビ朝日映像）</p>
                    <p>●この「ご利用上の注意」に規定されていない事項は、法令等に準じるものとします。</p>
                    <div class="about_notation">
                      <h4>表記について</h4>
                      <p>テレビ朝日映像アーカイブでは、1930年代から1945年に至る、日本軍による中国東北部侵略時代の地名・政体・事象に関する検索表記として、当時の呼称をそのまま使用しています。ご了承ください。</p>
                    </div><!-- .about_notation -->
                  </div><!-- .guide_box_inner -->
                </div><!-- .guide_box -->

              </div><!-- .guide_container -->

              <div id="movie_price" class="guide_container">
                <div class="guide_header header03">
                  <h2 class="guide_header_title" id="price">映像利用料金表<br /><span>（2019年4月1日現在）</span></h2>
                </div><!-- .guide_header -->

                <div class="guide_box">
                  <div class="guide_box_inner">
                    <p><img src="../assets/img/guide/price_list.png" alt="映像利用料金表" width="100%"></p>
                    <div class="price_caution">
                      <p>ご利用料金 = 使用料 + 業務費 + 複製費</p>
                      <p>※映像を貸し出した後、未使用の場合でも、業務費+複製費を請求させていただきます。<br />※上記料金は国内での使用を前提にしております。海外での使用については、あらかじめご相談ください。<br> ※ご不明な点、特殊ケースなどはお問い合わせください。 </p>
                      <p>特別映像：取材原版がフィルムのもの、希少性が高いと判断するもの<br />一般映像：上記特別映像以外のもの</p>
                    </div><!-- .price_caution -->
                  </div><!-- .guide_box_inner -->
                </div><!-- .guide_box -->

              </div><!-- .guide_container -->

              <div class="guide_container">
                <div class="guide_header header04">
                  <h2 class="guide_header_title">使用目的</h2>
                </div><!-- .guide_header -->
                <div class="guide_box">
                  <div class="guide_box_inner">
                    <dl class="purpose">
                      <dt>テレビ番組</dt>
                      <dd>CM以外の放送される番組（作品）</dd>
                      <dt>見逃し配信</dt>
                      <dd>ＴＶｅｒ、見逃し配信など視聴者サービスとして行われる二次利用初回放送分に対してのみ</dd>
                      <dt>映像商品</dt>
                      <dd>企業などが販売、頒布、社内使用等を目的として制作する作品<br><span>(販売用ビデオ、販促ビデオ、社内用ビデオなど、パッケージを頒布するもの)</span><br />※頒布の有料・無料は問いません。</dd>
                      <dt>インターネット配信</dt>
                      <dd>PC、モバイルなどインターネットを活用して配信・表示される作品<br>※有料、無料は問いません。</dd>
                      <dt>イベント</dt>
                      <dd><span class="palt">各種会場 （ショールーム、ロビー、ホール、スタジオ、スタジアムなど） で展示・使用する作品で、パッケージの頒布を伴わないもの</span><br />※入場料の有料・無料は問いません。※イベントの規模により、別に料金を定める場合があります。</dd>
                      <dt>劇場用映画</dt>
                      <dd>劇場・ホールなどで有料上映を目的として製作される作品</dd>
                      <dt>TVCM</dt>
                      <dd>商品 CM、企業 CM、告知 CM、テレビ番組内の生CMなど<br>※地上波、BS、CS、ケーブルテレビなどのメディアは問いません。</dd>
                      <dt>ネットほかＣＭ</dt>
                      <dd>商品 CM、企業 CM、告知 CM、テレビ番組内の生CMなど<br>※地上波、BS、CS、ケーブルテレビなどのメディアは問いません。</dd>
                    </dl>
                  </div><!-- .guide_box_inner -->
                </div><!-- .guide_box -->

              </div><!-- .guide_container -->

            </div><!-- #guide_contents_main -->

          </div><!-- #guide_contents -->
        </div><!-- #guide -->
      </div><!-- #works_guide_index -->
    </div><!-- #works_contents -->
  </div><!-- #works -->

</div><!-- #contents -->
</template>

<script>
import worksPageNav from './shared/worksPageNav.vue'
export default {
  name: 'guide',
  components: {
    worksPageNav
  },
  mounted () {

    // if (this.$route.hash.match(/^#/)) {
    //   document.getElementById(this.$route.hash.replace(/^#/, '')).scrollIntoView()
    // }
    this.$nextTick(() => {
      if (this.$route.hash) {
        var hash_value = this.$route.hash;
        scrollToAnker(hash_value);
      }
    });
    var url = location.href;
    var urlHashs = url.split('/')
    var hash = urlHashs[urlHashs.length-1]
    console.log(urlHashs[urlHashs.length-1])
    if(hash && hash.match(/#/)) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function () {
        scrollToAnker(hash);
      }, 100);
    }

    function scrollToAnker(hash) {
      var target = $(hash);
      var position = target.offset().top;
      $('body,html').stop().animate({scrollTop:position}, 500);
    }

    $('a[href^="#"]').click(function() {
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
   });

    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/guide.vue